import { default as FreeTextMultiValue } from './FreeTextMultiValue'
import { default as FreeTextMultiValues } from './FreeTextMultiValue'
import { default as SingleSelectRadioButton } from './SingleSelectRadioButton'
import { default as SingleSelectDropdownList } from './SingleSelectDropdownList'
import { default as PersonRelative } from './PersonRelative'
import { default as FreeTextRange } from './FreeTextRange'
import { default as FixedRange } from './FreeTextRange'
import { default as FixedSingleValue } from './FixedSingleValue'
import { default as FreeTextSingleValue } from './FixedSingleValue'
import { default as MultiSelectCheckBoxList } from './MultiSelectCheckBoxList'
import { default as MultiSelectAutocomplete } from './MultiSelectAutocomplete'
import { default as FixedList } from './FixedList'
import { default as SingleSelectAutocomplete } from './SingleSelectAutocomplete'

const FieldTypeDynamicComponents: any = {
    FreeTextMultiValue,
    SingleSelectRadioButton,
    SingleSelectDropdownList,
    PersonRelative,
    FreeTextRange,
    FixedRange,
    FixedSingleValue,
    FreeTextSingleValue,
    MultiSelectCheckBoxList,
    MultiSelectAutocomplete,
    FixedList,
    SingleSelectAutocomplete,
    FreeTextMultiValues,
}

export default FieldTypeDynamicComponents
